import { createContext, useContext } from "react";

export interface ChartMentions {
  // True until the names have arrived, so a missing name isn't yet "not available".
  loading?: boolean;
  // Field Insights chart id → name, for resolving `@chart:<id>` markers.
  names: ReadonlyMap<number, string>;
  // Supplied by the scene that owns the route; this package must not reach in.
  onOpen?: (chartId: number) => void;
}

const EMPTY: ChartMentions = { names: new Map() };

// Empty elsewhere, so a chart marker shows as not available.
const ChartMentionsContext = createContext<ChartMentions>(EMPTY);

export const useChartMentions = (): ChartMentions => useContext(ChartMentionsContext);

export default ChartMentionsContext;
